module.exports = __webpack_public_path__ + "img/face7.5bec44b8.png";